import React from "react";

const UserIcon = ({name, color, size}) => (
    <svg viewBox="0 0 32 24" className={`icon icon-user`} fill={color} width={size} height={size}  xmlns="http://www.w3.org/2000/svg">
        <path fillRule="nonzero" d="M23 8h10a1 1 0 0 1 0 2H23a1 1 0 0 1 0-2zm-2 13a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2zm-9-9a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm13 3h8a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2z" />
    </svg>
);

export default UserIcon;